import styled, { css, keyframes } from 'styled-components';

const fill = keyframes`
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
`;

export const Bar = styled.div(
  ({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    min-height: ${theme.sz.s8};
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.neutral90};
    overflow: hidden;
  `,
);

export const Fill = styled.div<{ $durationMs: number }>(
  ({ theme, $durationMs }) => css`
    position: absolute;
    inset: 0 auto 0 0;
    width: 0%;
    height: 100%;
    background-color: ${theme.co.primary50};
    animation: ${fill} ${$durationMs}ms linear forwards;
  `,
);

export const Label = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    position: relative;
    z-index: 1;
    color: ${theme.co.neutral10};
    font-weight: ${theme.DEPRECATED_ty.bold};
    padding: ${theme.sz.s2};
    text-align: center;
    max-width: none;
  `,
);
